<template>
  <div class="attendance-wrap" :class="{ done: isDone }">
    <div v-if="!isDone" class="content">
      <div class="main">
        <p class="desc">4자리 숫자 코드를 입력하세요.</p>
        <div class="code-inputs" :class="{ error: isError }">
          <div
            v-for="(v, i) in 4"
            :key="i"
            class="code-box"
            :class="{
              active: currentIndex === i && !isError && !isDone,
              filled: code[i],
              error: isError,
            }"
            @click="focusInput(i)"
          >
            <span v-if="code[i]">{{ code[i] }}</span>
            <span v-else>&nbsp;</span>
            <input
              ref="inputs"
              type="tel"
              maxlength="1"
              pattern="[0-9]*"
              inputmode="numeric"
              v-model="code[i]"
              @input="onInput(i)"
              @focus="currentIndex = i"
              @keydown.backspace="onBackspace(i, $event)"
              :tabindex="isDone ? -1 : 0"
            />
          </div>
        </div>
        <p v-if="isError" class="error-msg">*올바르지 않은 숫자입니다.</p>
        <button
          class="submit"
          :class="{ active: isFilled && !isSubmitting, error: isError }"
          :disabled="!isFilled || isDone || isSubmitting"
          @click="submit"
        >
        출석 완료
        </button>
        <div class="info">
          <p>*출석하시면 500CRC를 드립니다.</p>
          <p>*오전, 오후 사업 설명회에 건너 뛰는 날 없이 연속으로 10회 출석하신 경우 2,000CRC를 추가 보상으로 드립니다.</p>
          <p>*CRC는 오늘집밥에서 포인트로 사용 가능합니다.</p>
        </div>
      </div>
    </div>
    <div v-else class="done-wrap">
      <div class="done-icon-ani"></div>
      <p class="done-text">출석체크 완료</p>
      <button class="home-button" @click="goToHome">
        홈으로 이동
      </button>
    </div>
  </div>
</template>

<script>
import client from '../client/client';
import axios from '../client/clientAxios';

export default {
  name: "AttendanceCheck",
  data() {
    return {
      code: ["", "", "", ""],
      currentIndex: 0,
      isError: false,
      isDone: false,
      isSubmitting: false, // 제출 중 상태 추가
    };
  },
  computed: {
    isFilled() {
      return this.code.every((c) => c.length === 1);
    },
  },
  methods: {
    focusInput(i) {
      this.currentIndex = i;
      this.$refs.inputs[i].focus();
      setTimeout(() => {
        this.$refs.inputs[i].scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    },
    goToHome() {
      window.location.href = 'jevil://devil.com/rootScreen/main';
    },
    onInput(i) {
      this.isError = false;
      const val = this.code[i];
      if (!/^[0-9]$/.test(val)) {
        this.code[i] = "";
        return;
      }
      if (i < 3) {
        this.focusInput(i + 1);
      }
    },
    onBackspace(i, e) {
      if (this.code[i] === "" && i > 0) {
        this.focusInput(i - 1);
      }
    },
    async submit() {
      if (!this.isFilled || this.isSubmitting) return; // isSubmitting 체크 추가
      
      // 중복 제출 방지를 위해 상태 변경
      this.isSubmitting = true;
      
      // 현재 포커스된 입력 필드에서 포커스를 제거하여 키보드 내리기
      if (document.activeElement) {
        document.activeElement.blur();
      }
      
      // 키보드가 부드럽게 내려가도록 잠시 대기
      await new Promise(resolve => setTimeout(resolve, 100));
      
      this.isError = false;

      try {
        const query = this.$route.query;
        client.updateToken(query);
        
        const codeStr = this.code.join("");

        const result = await client.get(`/api/attendance/shahbet/check?code=${codeStr}`);
        
        if (result.r) {
          this.isDone = true;
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }, 100);
        } else {
          this.isError = true;
          this.code = ["", "", "", ""];
          this.focusInput(0);
          alert(result.msg || "출석 체크에 실패했습니다.");
        }
      } catch (e) {
        console.error('에러 내용:', e);
        this.isError = true;
        alert("서버 오류가 발생했습니다.");
      } finally {
        this.isSubmitting = false; // 작업 완료 후 상태 복원
      }
    },
  },
  mounted() {
    this.focusInput(0);
  },
};
</script>

<style lang="scss" scoped>
.attendance-wrap {
  width: 100%;
  background: #fff;
  font-family: 'Pretendard', sans-serif;
  position: relative;

  .content {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 0 4.44vw;
    box-sizing: border-box;
    min-height: 100vh;
    padding-top: 5.5556vw; 
    
    .main {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 8.89vw;
      width: 100%;
      
      .desc {
        font-size: 6.67vw;
        font-weight: 600;
        margin-bottom: 11.67vw;
        text-align: left;
        width: 100%;
      }

      .code-inputs {
        width: 100%;
        margin-bottom: auto;
        display: flex;
        gap: 4.44vw;
        margin-bottom: 4.44vw;
        justify-content: center;
        
        .code-box {
          width: 18.61vw;
          height: 19.72vw;
          border-radius: 3.33vw;
          border: 0.28vw solid #070707;
          background: #EDEFF2;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 7.78vw;
          font-weight: 600;
          position: relative;
          transition: border 0.2s, background 0.2s;
          
          input {
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            font-size: 10vw;
          }
          
          &.active {
            border: 0.56vw solid #F2632A;
            background: #fff;
          }
          
          &.filled {
            color: #222;
          }
          
          &.error {
            border: 0.56vw solid #ff3b30;
            color: #ff3b30;
            background: #fff;
          }
        }
        
        &.error .code-box {
          border: 0.56vw solid #F22A2A;
          color: #F22A2A;
          background: #fff;
        }
      }

      .error-msg {
        color: #F22A2A;
        font-size: 3.89vw;
        margin-bottom: 2.22vw;
        margin-top: -2.22vw;
        text-align: left;
        width: 100%;
        max-width: 88.89vw;
      }

      .info {
        width: 100%;
        margin: 6.67vw 0;
        p {
          font-size: 4.44vw;
          line-height: 1.5;
          margin: 0;
          color:#515151;
          & + p {
            margin-top: 3.33vw;
          }
        }
      }

      .submit {
        width: 100%;
        height: 13.33vw;
        margin-bottom: 4.44vw;
        border-radius: 3.33vw;
        border: none;
        background: #EDEFF2;
        color: #656565;
        font-size: 5.56vw;
        font-weight: 600;
        transition: background 0.2s, color 0.2s;
        
        &.active {
          background: #F2632A;
          color: #fff;
        }
        
        &.error {
          background: #f5f6f8;
          color: #F22A2A;
        }
        
        &:disabled {
          opacity: 1;
        }
      }
    }
  }

  .done-wrap {
    width: 100%;
    max-width: 360px;
    min-height: 100vh;
    padding-top: 60px; // 헤더 높이만큼 상단 패딩
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding-left: 4.44vw;
    padding-right: 4.44vw;
    box-sizing: border-box;

    .done-icon-ani {
      width: 20.56vw;
      height: 20.56vw;
      border-radius: 50%;
      background: #F2632A;
      position: relative;
      margin-bottom: 6.67vw;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        width: 8.33vw;
        height: 3.89vw;
        border-left: 1.67vw solid #fff;
        border-bottom: 1.67vw solid #fff;
        border-radius: 0.56vw;
        transform: translate(-50%, -50%) scaleX(0) scaleY(0) rotate(-45deg);
        opacity: 0;
        animation: check-ani 0.5s 0.2s forwards cubic-bezier(0.4, 0, 0.2, 1);
      }
    }

    .done-text {
      font-size: 7.78vw;
      margin: 6.67vw 0;
      font-weight: 600;
      color: #000;
      text-align: center;
    }

    .home-button {
      width: 100%;
      height: 13.33vw;
      margin-top: auto;
      margin-bottom: 4.44vw;
      border-radius: 3.33vw;
      border: none;
      background: #F2632A;
      color: #fff;
      font-size: 5.56vw;
      font-weight: 600;
      transition: background 0.2s;
      
      &:active {
        background: darken(#F2632A, 10%);
      }
    }
  }
}

@keyframes check-ani {
  0% {
    transform: translate(-50%, -50%) scaleX(0) scaleY(0) rotate(-45deg);
    opacity: 0;
  }
  60% {
    transform: translate(-50%, -50%) scaleX(1.1) scaleY(1.1) rotate(-45deg);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scaleX(1) scaleY(1) rotate(-45deg);
    opacity: 1;
  }
}

@media (max-width: 77.78vw) {
  .attendance-wrap .main {
    .desc {
      font-size: 5vw;
    }
    .code-inputs {
      gap: 2.22vw;
      .code-box {
        width: 14.44vw;
        height: 15.56vw;
        input {
          font-size: 6.67vw;
        }
      }
    }
    .info {
      font-size: 3.33vw;
      color:#515151;
    }
    .submit {
      height: 13.33vw;
      font-size: 4.44vw;
    }
    .error-msg {
      font-size: 3.33vw;
    }
  }
}

// 갤럭시 폴드 대응
@media screen and (min-width: 700px) {
  .attendance-wrap {
    .content, .done-wrap {
      max-width: 360px;  // 최대 너비 유지
      padding: 0 16px;   // 큰 화면에서는 고정 패딩
    }
  }
}
</style>